import { useQueryParams } from '@hooks/useQueryParams';
import {
  ORDER_AFFILIATE_PARAMETERS,
  ORDER_AFFILIATE_ORDER,
  ORDER_AFFILIATE_EMITTEN,
  ORDER_AFFILIATE_PRICE,
  ORDER_AfFILIATE_AFFILIATE_ID,
} from '@constants/__deprecated__/order-affiliate';

export const useOrderAffiliate = () => {
  const { queryParams } = useQueryParams();

  const isOrderAffiliateAvailable = ORDER_AFFILIATE_PARAMETERS.every((orderAffiliateParameter) =>
    queryParams.has(orderAffiliateParameter)
  );

  return {
    isOrderAffiliateAvailable,
    [ORDER_AFFILIATE_ORDER]: queryParams.get(ORDER_AFFILIATE_ORDER),
    [ORDER_AFFILIATE_EMITTEN]: queryParams.get(ORDER_AFFILIATE_EMITTEN),
    [ORDER_AFFILIATE_PRICE]: queryParams.get(ORDER_AFFILIATE_PRICE),
    [ORDER_AfFILIATE_AFFILIATE_ID]: queryParams.get(ORDER_AfFILIATE_AFFILIATE_ID),
  };
};
